import { Link, useLocation, useNavigate } from "react-router-dom";
import { Routes } from "../../constants/RouteConstants";
import authContext from "../../context/authContext";
import { useContext } from "react";
import toast from "react-hot-toast";
import { checkPermission, hasAnySubscription } from "../../utils/Helper";
import UpgradeToast from "./UpgradeToast";
import { PERMISSIONS } from "../../constants/Constants";

const BottomMenu = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const profile: any = useContext(authContext);
  const hasSubscription = hasAnySubscription(profile?.data);

  return (
    <>
      <nav className="bottom-menubar" aria-label="Bottom Navigation">
        <div className="row gx-2 gx-sm-4">
          {/* Dashboard Menu Item */}
          <div className={`col-3`}>
            <Link
              to={Routes?.Dashboard}
              className={`menubar-single ${pathname === Routes?.Dashboard ? "active" : ""
                }`}
            >
              <div className="menu-icon-wrap menu-home-icon">
                {pathname === Routes?.Dashboard ? (
                  // Active Dashboard Icon (filled)
                  <svg className="menu-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21.75 8.79102V22.249H2.25V8.79102L12 1.75L21.75 8.79102ZM14.3857 16.2119C13.765 16.6951 12.9317 17.001 12 17.001C11.1847 17.0009 10.4445 16.7671 9.85645 16.3848L9.61426 16.2119L8.8252 15.5977L7.59668 17.1758L8.38574 17.79L8.57227 17.9287C9.5226 18.6057 10.7167 19.0009 12 19.001C13.3687 19.001 14.636 18.5515 15.6143 17.79L16.4033 17.1758L15.1748 15.5977L14.3857 16.2119Z" fill="currentColor" />
                  </svg>
                ) : (
                  // Inactive Dashboard Icon (outline)
                  <svg className="menu-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3 9V21.5H21V9L12 2.5L3 9Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="square" />
                    <path d="M15 17C14.2005 17.6224 13.1502 18 12 18C10.8497 18 9.79953 17.6224 9 17" stroke="currentColor" stroke-width="1.5" stroke-linecap="square" />
                  </svg>

                )}
              </div>
              <span className="menu-ttl">Dashboard</span>
            </Link>
          </div>

          {/* Chores Menu Item */}
          <div
            className={`col-3`}
          >
            <a
              onClick={() => {
                if (!hasSubscription) {
                  toast.dismiss();
                  toast.custom((t) => <UpgradeToast t={t} />, { id: "upgrade-toast", duration: 3000 });
                } else {
                  profile?.data?.hh_member
                    ? navigate(Routes?.Chores)
                    : toast.error("Please create a household first.");
                }
              }}
              tabIndex={0}
              role="button"
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  e.currentTarget.click();
                }
              }}
              className={`menubar-single cursor-pointer ${pathname === Routes?.Chores ? "active" : ""
                } ${!hasSubscription ? "disabled-menubar-single" : ""}`}
            >
              <div className="menu-icon-wrap">
                {pathname === Routes?.Chores ? (
                  // Active Chores Icon (filled)
                  <svg className="menu-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.25 3V6.5H5.25V3H7.25V6.5H8.25V3H10.25V7.35224C10.25 8.7786 9.80618 9.94617 9.04652 10.7672C8.53972 11.315 7.91501 11.6825 7.25 11.8651V21H5.25V11.8651C4.58498 11.6824 3.96026 11.3149 3.45347 10.7671C2.69382 9.94601 2.25 8.77843 2.25 7.35208V3H4.25Z" fill="currentColor" />
                    <path d="M21 2.25C15.6152 2.25 11.25 6.61522 11.25 12C11.25 17.3848 15.6152 21.75 21 21.75H21.75V18H21C17.6863 18 15 15.3137 15 12C15 8.68629 17.6863 6 21 6H21.75V2.25H21Z" fill="currentColor" />
                    <path d="M21.75 8H21C18.7909 8 17 9.79086 17 12C17 14.2091 18.7909 16 21 16H21.75V8Z" fill="currentColor" />
                  </svg>

                ) : (
                  // Inactive Chores Icon (outline)
                  <svg className="menu-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21 17.0008C18.2386 17.0008 16 14.7622 16 12.0008C16 9.23937 18.2386 7.00079 21 7.00079" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" />
                    <path d="M21 21C16.0294 21 12 16.9706 12 12C12 7.02944 16.0294 3 21 3" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" />
                    <path d="M6 3V7.5M6 21V11" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" />
                    <path d="M3 7.5H9" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" />
                    <path d="M9 3V7.35224C9 12.216 3 12.2159 3 7.35207V3" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" />
                  </svg>

                )}
              </div>
              <span className="menu-ttl">Chores</span>
            </a>
          </div>

          {/* Expenses Menu Item */}
          <div
            className={`col-3`}
          >
            <a
              onClick={() => {
                if (!hasSubscription) {
                  toast.dismiss();
                  toast.custom((t) => <UpgradeToast t={t} />, { id: "upgrade-toast", duration: 3000 });
                } else {
                  profile?.data?.hh_member
                    ? navigate(Routes?.Expenses)
                    : toast.error("Please create a household first.");
                }
              }}
              tabIndex={0}
              role="button"
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  e.currentTarget.click();
                }
              }}
              className={`menubar-single cursor-pointer ${pathname === Routes?.Expenses ? "active" : ""
                } ${!hasSubscription ? "disabled-menubar-single" : ""}`}
            >
              <div className="menu-icon-wrap">
                {pathname === Routes?.Expenses ? (
                  // Active Expenses Icon (filled)
                  <svg className="menu-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M1.25 4C1.25 3.58579 1.58579 3.25 2 3.25H22C22.4142 3.25 22.75 3.58579 22.75 4V8.25H1.25V4ZM1.25 9.75H22.75V20C22.75 20.4142 22.4142 20.75 22 20.75H2C1.58579 20.75 1.25 20.4142 1.25 20V9.75ZM11 16.75H13V15.25H11V16.75ZM15 16.75H19V15.25H15V16.75Z" fill="currentColor" />
                  </svg>

                ) : (
                  // Inactive Expenses Icon (outline)
                  <svg className="menu-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M22 4H2V20H22V4Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M11 16H13M15 16H19" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linejoin="round" />
                    <path d="M2 9H22" stroke="currentColor" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round" />
                  </svg>
                )}
              </div>
              <span className="menu-ttl">Expenses</span>
            </a>
          </div>

          {/* Contributions Menu Item */}
          <div
            className={`col-3`}
          >
            <a
              onClick={() => {
                if (!hasSubscription) {
                  toast.dismiss();
                  toast.custom((t) => <UpgradeToast t={t} />, { id: "upgrade-toast", duration: 3000 });
                } else {
                  profile?.data?.hh_member
                    ? navigate(Routes?.Contributions)
                    : toast.error("Please create a household first.");
                }
              }}
              tabIndex={0}
              role="button"
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  e.currentTarget.click();
                }
              }}
              className={`menubar-single ${pathname === Routes?.Contributions ? "active" : ""
                } ${!hasSubscription ? "disabled-menubar-single" : ""}`}
            >
              <div className="menu-icon-wrap">
                {pathname === Routes?.Contributions ? (
                  // Active Contributions Icon (filled)
                  <svg className="menu-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16.6586 14.8074L12.7161 16.1902C12.723 16.2105 12.7286 16.2314 12.733 16.2529C12.7761 16.4658 12.7987 16.6866 12.7987 16.9129C12.7987 17.3084 12.5584 17.6821 12.1717 17.8033L9.33295 18.6931C8.62969 18.9136 7.87685 18.836 7.22606 18.479L4.8761 16.9722L5.40659 16.1281L7.71218 17.6078C8.12797 17.8312 8.59943 17.8761 9.03979 17.738L11.7406 16.8914V16.7579C11.6685 15.7772 10.9181 14.9913 9.98566 14.9913H8.82083C8.45035 14.9913 8.08463 14.8967 7.75252 14.7145L5.47122 13.4631C5.21547 13.3228 4.93297 13.2495 4.6462 13.2495H2.25V20.3218L9.19484 22.6582C9.70827 22.831 10.2591 22.7568 10.7273 22.4506L19.75 16.5974C19.0349 14.674 17.4503 14.5278 16.6586 14.8074Z" fill="currentColor" />
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.35273 13.6186L7.42889 13.1118C6.68129 11.92 6.24902 10.5102 6.24902 8.99951C6.24902 4.7193 9.71882 1.24951 13.999 1.24951C18.2792 1.24951 21.749 4.7193 21.749 8.99951C21.749 11.0482 20.9541 12.9113 19.6559 14.2971C19.363 14.0508 19.0444 13.8598 18.7102 13.7214C17.8248 13.3548 16.912 13.3923 16.2427 13.6283L12.3737 14.9853C11.8419 14.2484 11.002 13.7413 9.98468 13.7413H8.81985C8.66392 13.7413 8.50446 13.7018 8.35273 13.6186ZM12.1348 4.83885C12.4533 4.59999 12.8348 4.42759 13.249 4.3331V3.49951H14.749V4.33402C15.5377 4.51466 16.2337 4.97977 16.5636 5.67978L15.2068 6.31923C15.0895 6.07048 14.6674 5.74951 13.999 5.74951C13.5933 5.74951 13.2549 5.87378 13.0348 6.03885C12.8149 6.20374 12.749 6.37429 12.749 6.49951C12.749 6.62473 12.8149 6.79527 13.0348 6.96017C13.2549 7.12523 13.5933 7.24951 13.999 7.24951C14.6979 7.24951 15.3594 7.46102 15.8632 7.83885C16.3672 8.21685 16.749 8.7963 16.749 9.49951C16.749 10.2027 16.3672 10.7822 15.8632 11.1602C15.5447 11.399 15.1632 11.5714 14.749 11.6659V12.4995H13.249V11.665C12.4603 11.4844 11.7643 11.0193 11.4344 10.3192L12.7912 9.67978C12.9085 9.92853 13.3306 10.2495 13.999 10.2495C14.4047 10.2495 14.7431 10.1252 14.9632 9.96017C15.1831 9.79527 15.249 9.62473 15.249 9.49951C15.249 9.37429 15.1831 9.20374 14.9632 9.03885C14.7431 8.87378 14.4047 8.74951 13.999 8.74951C13.3001 8.74951 12.6386 8.53799 12.1348 8.16017C11.6308 7.78217 11.249 7.20272 11.249 6.49951C11.249 5.7963 11.6308 5.21685 12.1348 4.83885Z" fill="currentColor" />
                  </svg>
                ) : (
                  // Inactive Contributions Icon (outline)
                  <svg className="menu-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19.7443 12.9995C20.5352 11.8657 20.999 10.4867 20.999 8.99951C20.999 5.13352 17.865 1.99951 13.999 1.99951C10.133 1.99951 6.99902 5.13351 6.99902 8.99951C6.99902 10.0731 7.24071 11.0902 7.67265 11.9995" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" />
                    <path d="M14 6C12.8954 6 12 6.67157 12 7.5C12 8.32843 12.8954 9 14 9C15.1046 9 16 9.67157 16 10.5C16 11.3284 15.1046 12 14 12M14 6C14.8708 6 15.6116 6.4174 15.8862 7M14 6V4.5M14 12C13.1292 12 12.3884 11.5826 12.1138 11M14 12V13.5" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" />
                    <path d="M3 13.9995H6L8.5 15.3746H9.5C11 15.3746 12 16.5235 12 17.4993L9 18.4993L6 17.4993M11.9993 16.9995L16.2103 15.5958C17.2149 15.261 18.3064 15.7672 18.6997 16.7504L18.9993 17.4995L9.99931 21.9995L3 20.0194" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" />
                  </svg>
                )}
              </div>
              <span className="menu-ttl">Contributions</span>
            </a>
          </div>
        </div>
      </nav>
    </>
  );

};

export default BottomMenu;